/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { BaseDataApiConfiguration } from '../base-data-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createSetupParameterKinds } from '../fn/setup-parameter/create-setup-parameter-kinds';
import { CreateSetupParameterKinds$Params } from '../fn/setup-parameter/create-setup-parameter-kinds';
import { createSetupParameterTemplateListValues } from '../fn/setup-parameter/create-setup-parameter-template-list-values';
import { CreateSetupParameterTemplateListValues$Params } from '../fn/setup-parameter/create-setup-parameter-template-list-values';
import { createSetupParameterTemplates } from '../fn/setup-parameter/create-setup-parameter-templates';
import { CreateSetupParameterTemplates$Params } from '../fn/setup-parameter/create-setup-parameter-templates';
import { deleteSetupParameterKinds } from '../fn/setup-parameter/delete-setup-parameter-kinds';
import { DeleteSetupParameterKinds$Params } from '../fn/setup-parameter/delete-setup-parameter-kinds';
import { deleteSetupParameterTemplateListValues } from '../fn/setup-parameter/delete-setup-parameter-template-list-values';
import { DeleteSetupParameterTemplateListValues$Params } from '../fn/setup-parameter/delete-setup-parameter-template-list-values';
import { deleteSetupParameterTemplates } from '../fn/setup-parameter/delete-setup-parameter-templates';
import { DeleteSetupParameterTemplates$Params } from '../fn/setup-parameter/delete-setup-parameter-templates';
import { getSetupParameterKindByExternalId } from '../fn/setup-parameter/get-setup-parameter-kind-by-external-id';
import { GetSetupParameterKindByExternalId$Params } from '../fn/setup-parameter/get-setup-parameter-kind-by-external-id';
import { getSetupParameterKindById } from '../fn/setup-parameter/get-setup-parameter-kind-by-id';
import { GetSetupParameterKindById$Params } from '../fn/setup-parameter/get-setup-parameter-kind-by-id';
import { getSetupParameterKinds } from '../fn/setup-parameter/get-setup-parameter-kinds';
import { GetSetupParameterKinds$Params } from '../fn/setup-parameter/get-setup-parameter-kinds';
import { getSetupParameterTemplateById } from '../fn/setup-parameter/get-setup-parameter-template-by-id';
import { GetSetupParameterTemplateById$Params } from '../fn/setup-parameter/get-setup-parameter-template-by-id';
import { getSetupParameterTemplateListValueById } from '../fn/setup-parameter/get-setup-parameter-template-list-value-by-id';
import { GetSetupParameterTemplateListValueById$Params } from '../fn/setup-parameter/get-setup-parameter-template-list-value-by-id';
import { getSetupParameterTemplateListValues } from '../fn/setup-parameter/get-setup-parameter-template-list-values';
import { GetSetupParameterTemplateListValues$Params } from '../fn/setup-parameter/get-setup-parameter-template-list-values';
import { getSetupParameterTemplates } from '../fn/setup-parameter/get-setup-parameter-templates';
import { GetSetupParameterTemplates$Params } from '../fn/setup-parameter/get-setup-parameter-templates';
import { SetupParameterKindListViewModel } from '../models/setup-parameter-kind-list-view-model';
import { SetupParameterTemplateListValueListViewModel } from '../models/setup-parameter-template-list-value-list-view-model';
import { SetupParameterTemplateListViewModel } from '../models/setup-parameter-template-list-view-model';
import { updateSetupParameterKinds } from '../fn/setup-parameter/update-setup-parameter-kinds';
import { UpdateSetupParameterKinds$Params } from '../fn/setup-parameter/update-setup-parameter-kinds';
import { updateSetupParameterTemplateListValues } from '../fn/setup-parameter/update-setup-parameter-template-list-values';
import { UpdateSetupParameterTemplateListValues$Params } from '../fn/setup-parameter/update-setup-parameter-template-list-values';
import { updateSetupParameterTemplates } from '../fn/setup-parameter/update-setup-parameter-templates';
import { UpdateSetupParameterTemplates$Params } from '../fn/setup-parameter/update-setup-parameter-templates';

@Injectable({ providedIn: 'root' })
export class SetupParameterService extends BaseService {
  constructor(config: BaseDataApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `createSetupParameterKinds()` */
  static readonly CreateSetupParameterKindsPath = '/api/v1/SetupParameter/CreateSetupParameterKindsList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSetupParameterKinds()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSetupParameterKinds$Response(params: CreateSetupParameterKinds$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createSetupParameterKinds(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSetupParameterKinds$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSetupParameterKinds(params: CreateSetupParameterKinds$Params, context?: HttpContext): Observable<void> {
    return this.createSetupParameterKinds$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateSetupParameterKinds()` */
  static readonly UpdateSetupParameterKindsPath = '/api/v1/SetupParameter/UpdateSetupParameterKindsList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSetupParameterKinds()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSetupParameterKinds$Response(params: UpdateSetupParameterKinds$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateSetupParameterKinds(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSetupParameterKinds$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSetupParameterKinds(params: UpdateSetupParameterKinds$Params, context?: HttpContext): Observable<void> {
    return this.updateSetupParameterKinds$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteSetupParameterKinds()` */
  static readonly DeleteSetupParameterKindsPath = '/api/v1/SetupParameter/DeleteSetupParameterKindsList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSetupParameterKinds()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteSetupParameterKinds$Response(params: DeleteSetupParameterKinds$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteSetupParameterKinds(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSetupParameterKinds$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteSetupParameterKinds(params: DeleteSetupParameterKinds$Params, context?: HttpContext): Observable<void> {
    return this.deleteSetupParameterKinds$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createSetupParameterTemplates()` */
  static readonly CreateSetupParameterTemplatesPath = '/api/v1/SetupParameter/CreateSetupParameterTemplatesList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSetupParameterTemplates()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSetupParameterTemplates$Response(params: CreateSetupParameterTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createSetupParameterTemplates(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSetupParameterTemplates$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSetupParameterTemplates(params: CreateSetupParameterTemplates$Params, context?: HttpContext): Observable<void> {
    return this.createSetupParameterTemplates$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateSetupParameterTemplates()` */
  static readonly UpdateSetupParameterTemplatesPath = '/api/v1/SetupParameter/UpdateSetupParameterTemplatesList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSetupParameterTemplates()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSetupParameterTemplates$Response(params: UpdateSetupParameterTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateSetupParameterTemplates(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSetupParameterTemplates$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSetupParameterTemplates(params: UpdateSetupParameterTemplates$Params, context?: HttpContext): Observable<void> {
    return this.updateSetupParameterTemplates$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteSetupParameterTemplates()` */
  static readonly DeleteSetupParameterTemplatesPath = '/api/v1/SetupParameter/DeleteSetupParameterTemplatesList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSetupParameterTemplates()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteSetupParameterTemplates$Response(params: DeleteSetupParameterTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteSetupParameterTemplates(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSetupParameterTemplates$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteSetupParameterTemplates(params: DeleteSetupParameterTemplates$Params, context?: HttpContext): Observable<void> {
    return this.deleteSetupParameterTemplates$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `createSetupParameterTemplateListValues()` */
  static readonly CreateSetupParameterTemplateListValuesPath = '/api/v1/SetupParameter/CreateSetupParameterTemplateListValuesList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSetupParameterTemplateListValues()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSetupParameterTemplateListValues$Response(params: CreateSetupParameterTemplateListValues$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createSetupParameterTemplateListValues(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSetupParameterTemplateListValues$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSetupParameterTemplateListValues(params: CreateSetupParameterTemplateListValues$Params, context?: HttpContext): Observable<void> {
    return this.createSetupParameterTemplateListValues$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateSetupParameterTemplateListValues()` */
  static readonly UpdateSetupParameterTemplateListValuesPath = '/api/v1/SetupParameter/UpdateSetupParameterTemplateListValuesList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSetupParameterTemplateListValues()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSetupParameterTemplateListValues$Response(params: UpdateSetupParameterTemplateListValues$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateSetupParameterTemplateListValues(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSetupParameterTemplateListValues$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSetupParameterTemplateListValues(params: UpdateSetupParameterTemplateListValues$Params, context?: HttpContext): Observable<void> {
    return this.updateSetupParameterTemplateListValues$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteSetupParameterTemplateListValues()` */
  static readonly DeleteSetupParameterTemplateListValuesPath = '/api/v1/SetupParameter/DeleteSetupParameterTemplateListValuesList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSetupParameterTemplateListValues()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteSetupParameterTemplateListValues$Response(params: DeleteSetupParameterTemplateListValues$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteSetupParameterTemplateListValues(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSetupParameterTemplateListValues$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteSetupParameterTemplateListValues(params: DeleteSetupParameterTemplateListValues$Params, context?: HttpContext): Observable<void> {
    return this.deleteSetupParameterTemplateListValues$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getSetupParameterKindById()` */
  static readonly GetSetupParameterKindByIdPath = '/api/v1/SetupParameter/GetSetupParameterKindById/{setupParameterKindId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSetupParameterKindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSetupParameterKindById$Response(params: GetSetupParameterKindById$Params, context?: HttpContext): Observable<StrictHttpResponse<SetupParameterKindListViewModel>> {
    return getSetupParameterKindById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSetupParameterKindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSetupParameterKindById(params: GetSetupParameterKindById$Params, context?: HttpContext): Observable<SetupParameterKindListViewModel> {
    return this.getSetupParameterKindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<SetupParameterKindListViewModel>): SetupParameterKindListViewModel => r.body)
    );
  }

  /** Path part for operation `getSetupParameterKindByExternalId()` */
  static readonly GetSetupParameterKindByExternalIdPath = '/api/v1/SetupParameter/GetSetupParameterKindByExternalId/{externalSetupParameterKindId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSetupParameterKindByExternalId()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSetupParameterKindByExternalId$Response(params: GetSetupParameterKindByExternalId$Params, context?: HttpContext): Observable<StrictHttpResponse<SetupParameterKindListViewModel>> {
    return getSetupParameterKindByExternalId(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSetupParameterKindByExternalId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSetupParameterKindByExternalId(params: GetSetupParameterKindByExternalId$Params, context?: HttpContext): Observable<SetupParameterKindListViewModel> {
    return this.getSetupParameterKindByExternalId$Response(params, context).pipe(
      map((r: StrictHttpResponse<SetupParameterKindListViewModel>): SetupParameterKindListViewModel => r.body)
    );
  }

  /** Path part for operation `getSetupParameterKinds()` */
  static readonly GetSetupParameterKindsPath = '/api/v1/SetupParameter/GetSetupParameterKinds';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSetupParameterKinds()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSetupParameterKinds$Response(params?: GetSetupParameterKinds$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SetupParameterKindListViewModel>>> {
    return getSetupParameterKinds(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSetupParameterKinds$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSetupParameterKinds(params?: GetSetupParameterKinds$Params, context?: HttpContext): Observable<Array<SetupParameterKindListViewModel>> {
    return this.getSetupParameterKinds$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SetupParameterKindListViewModel>>): Array<SetupParameterKindListViewModel> => r.body)
    );
  }

  /** Path part for operation `getSetupParameterTemplateById()` */
  static readonly GetSetupParameterTemplateByIdPath = '/api/v1/SetupParameter/GetSetupParameterTemplateById/{setupParameterTemplateId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSetupParameterTemplateById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSetupParameterTemplateById$Response(params: GetSetupParameterTemplateById$Params, context?: HttpContext): Observable<StrictHttpResponse<SetupParameterTemplateListViewModel>> {
    return getSetupParameterTemplateById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSetupParameterTemplateById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSetupParameterTemplateById(params: GetSetupParameterTemplateById$Params, context?: HttpContext): Observable<SetupParameterTemplateListViewModel> {
    return this.getSetupParameterTemplateById$Response(params, context).pipe(
      map((r: StrictHttpResponse<SetupParameterTemplateListViewModel>): SetupParameterTemplateListViewModel => r.body)
    );
  }

  /** Path part for operation `getSetupParameterTemplates()` */
  static readonly GetSetupParameterTemplatesPath = '/api/v1/SetupParameter/GetSetupParameterTemplates';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSetupParameterTemplates()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSetupParameterTemplates$Response(params?: GetSetupParameterTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SetupParameterTemplateListViewModel>>> {
    return getSetupParameterTemplates(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSetupParameterTemplates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSetupParameterTemplates(params?: GetSetupParameterTemplates$Params, context?: HttpContext): Observable<Array<SetupParameterTemplateListViewModel>> {
    return this.getSetupParameterTemplates$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SetupParameterTemplateListViewModel>>): Array<SetupParameterTemplateListViewModel> => r.body)
    );
  }

  /** Path part for operation `getSetupParameterTemplateListValueById()` */
  static readonly GetSetupParameterTemplateListValueByIdPath = '/api/v1/SetupParameter/GetSetupParameterTemplateListValueById/{setupParameterTemplateListValueId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSetupParameterTemplateListValueById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSetupParameterTemplateListValueById$Response(params: GetSetupParameterTemplateListValueById$Params, context?: HttpContext): Observable<StrictHttpResponse<SetupParameterTemplateListValueListViewModel>> {
    return getSetupParameterTemplateListValueById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSetupParameterTemplateListValueById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSetupParameterTemplateListValueById(params: GetSetupParameterTemplateListValueById$Params, context?: HttpContext): Observable<SetupParameterTemplateListValueListViewModel> {
    return this.getSetupParameterTemplateListValueById$Response(params, context).pipe(
      map((r: StrictHttpResponse<SetupParameterTemplateListValueListViewModel>): SetupParameterTemplateListValueListViewModel => r.body)
    );
  }

  /** Path part for operation `getSetupParameterTemplateListValues()` */
  static readonly GetSetupParameterTemplateListValuesPath = '/api/v1/SetupParameter/GetSetupParameterTemplateListValues';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSetupParameterTemplateListValues()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSetupParameterTemplateListValues$Response(params?: GetSetupParameterTemplateListValues$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SetupParameterTemplateListValueListViewModel>>> {
    return getSetupParameterTemplateListValues(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSetupParameterTemplateListValues$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSetupParameterTemplateListValues(params?: GetSetupParameterTemplateListValues$Params, context?: HttpContext): Observable<Array<SetupParameterTemplateListValueListViewModel>> {
    return this.getSetupParameterTemplateListValues$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SetupParameterTemplateListValueListViewModel>>): Array<SetupParameterTemplateListValueListViewModel> => r.body)
    );
  }

}
